module.exports = __webpack_public_path__ + "static/media/purple-t.1d9d2fde.svg";